export const authentication = {
    activeChangePasswordStrategy: false,
    validateEmailStrategyActivated: false,
    displayGARHelper: false,
    displayLoginLogo: true,
    enableGAR: true,
    enableSSO: false,
    firstConnexionRedirection: {
        trainer: '/groups/list/groups'
    },
    overrideDefaultRouteByRole: {
        learner: '/home',
        trainer: '/home',
    },
    licenceLink: 'https://www.catalogue.education/i-love-english-and-co/',// lien vers formulaire licence
    specificRedirectionPath: 'followed/tab',
    forceOpenModalNotificationAutoToFalse: true, // to remove when back will be ok and send true when true and false when false on auto field back request page-table
    redirectLearnerToAppAfterLogin: true,
};
